import { NotificationName } from 'typings/enums';
import { NotificationItemPromotionRequest } from 'nomst/Stores/Notification/notificationItemPromotionRequest';

export class NotificationItemPromotionRequestUpdated extends NotificationItemPromotionRequest {

    declare data: INotificationDataPromotionRequestUpdated;

    constructor(props: IBaseNotificationItem) {
        super(props);
        this.notificationName = NotificationName.NotificationDataPromotionRequestUpdated;
    }

    get iconCss(): string {
        return 'icon-feather';
    }

    get titleText(): string {
        return `Changes - ${this.data.employeeName}`;
    }

    get contentText(): string {
        return `${this.data.updatedBy} made changes`;
    }
}